import { axiosInstance } from "..";
import Cookies from "js-cookie";

export const threadsInTopicApi = async (topicId: any) => {
  const config = {
    params: {
      topicId: topicId,
    },
  };

  const body = JSON.stringify({ topicId: topicId });
  const response = await axiosInstance.get("api/getThreadsInTopic", config);

  if (response.status !== 200) {
    return null;
  }
  return response.data;
};

export const threadContentApi = async (topicId: any, threadId: any) => {
  const config = {
    params: {
      topicId: topicId,
      threadId: threadId,
    },
  };
  const response = await axiosInstance.get("api/getThreadContent", config);

  if (response.status !== 200) {
    return null;
  }
  return response.data;
};

export const getCommentContentApi = async (threadId: any) => {
  const config = {
    params: {
      threadId: threadId,
    },
  };
  const response = await axiosInstance.get("api/getComments", config);

  if (response.status !== 200) {
    return null;
  }
  return response.data;
};

export const newThreadApi = async (formData: FormData) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    withCredentials: true,
  };
  const response = await axiosInstance.post("api/newThread", formData, config);

  if (response.status === 200) {
    return response.data.threadId;
  }
};

export const newCommentApi = async (formData: FormData) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    withCredentials: true,
  };
  const response = await axiosInstance.post("api/newComment", formData, config);

  if (response.status === 200) {
    return response.data.message;
  }
};

export const deleteCommentApi = async (commentId: number) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    params: {
      commentId: commentId
    },
    withCredentials: true,
  };
  const response = await axiosInstance.delete("api/deleteComment", config)

  return response
}

export const deleteThreadApi = async (threadId: number, userId: string) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    params: {
      threadId: threadId,
      userId: userId
    },
    withCredentials: true,
  };
  const response = await axiosInstance.delete("api/deleteThread", config)
  return response
}